import { publicUrl, locale, env } from 'utils/settings';
import Translations from '../../../public/phrase/en-XZ.json';

const fetchPhraseIfNeeded = () => {
    if (window.ikea?.favourites?.text) {
        return Promise.resolve();
    }
    const path =
        env === 'localhost'
            ? `${publicUrl}phrase/${locale}.json`
            : `${publicUrl}agent/phrase/${locale}.json`;
    return fetch(path)
        .then(response => response.json())
        .then((text: typeof Translations) => {
            window.ikea.favourites.text = text;
        })
        .catch(err => console.error('Can´t get translations file', err));
};

export default fetchPhraseIfNeeded;
